import { Grid } from '@mui/material';
import {
  BasicModal,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';

export interface AddBuildScenarioModalProps {
  open: boolean;
  handleModalClose: () => void;
  handleConfirm: () => void;
  scenarioInfo: {
    name: string;
    notes?: string;
  };
  setScenarioInfo: React.Dispatch<
    React.SetStateAction<{
      name: string;
      notes?: string;
    }>
  >;
  title?: string;
  fieldName?: string;
  fieldPlaceholder?: string;
}

export const getFieldTypography = (label: string, margin: string) => {
  return (
    <Typography
      fontSize="12px"
      fontType="regular"
      lineHeight="24px"
      textColor={patientAccessTheme.palette.text.highemphasis}
      margin={margin}
    >
      {label}
    </Typography>
  );
};

const AddBuildScenarioModal: React.FC<AddBuildScenarioModalProps> = ({
  open,
  handleModalClose,
  handleConfirm,
  scenarioInfo,
  setScenarioInfo,
  title = 'Build Scenario',
  fieldName = 'Scenario Name*',
  fieldPlaceholder = 'Enter Scenario Name',
}) => {
  const handleScenarioChange = (e: any, fieldName: string) => {
    const value = e.target.value as string;
    setScenarioInfo((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  return (
    <div>
      {open && (
        <BasicModal
          open={open}
          title={title}
          width="500px"
          rootStyles={{ padding: 0 }}
          body={
            <Grid>
              {getFieldTypography(fieldName, '0px 0px 10px 0px')}
              <TextField
                value={scenarioInfo?.name}
                onChange={(e: any) => handleScenarioChange(e, 'name')}
                placeholder={fieldPlaceholder}
                height="36px"
                width="452px"
              />
              {getFieldTypography(
                'Notes/Remarks (Optional)',
                '20px 0px 10px 0px',
              )}
              <TextField
                value={scenarioInfo?.notes}
                onChange={(e: any) => handleScenarioChange(e, 'notes')}
                placeholder="Enter Notes/Remarks"
                height="36px"
                width="452px"
              />
            </Grid>
          }
          cancelButtonLabel={'Cancel'}
          confirmButtonLabel={'Save'}
          handleCancel={handleModalClose}
          handleConfirm={handleConfirm}
          handleClose={handleModalClose}
          isConfirmDisabled={scenarioInfo?.name?.trim() === ''}
        />
      )}
    </div>
  );
};

export default AddBuildScenarioModal;
